import RadioButtonField from './RadioButtonField';
import RadioButtonGroup from './RadioButtonGroup';
const RadioButton = {
  Field: RadioButtonField,
  Group: RadioButtonGroup,
};
export default RadioButton;
